// extracted by mini-css-extract-plugin
export default {"step":"Step1_step__SSmuI","title":"Step1_title__VO6ww","description":"Step1_description__FS7sN","titleContainer":"Step1_titleContainer__ASbOy"};